import { $, ko } from 'enova-web-common';
import '../styles';
import MenuViewModel from '../viewmodels/menu-viewmodel';

function isTekstNøkkel(text) {
  return /^\s*[\wæøå]+\.[\wæøå.-]+\s*$/i.test(text);
}

$(() => {
  const menu = $('.layout--header .menu-desktop')[0];
  if (menu) {
    ko.applyBindings(new MenuViewModel({ oneMenuAtOnce: true }), menu);
  }

  const menuMobile = $('.layout--header .menu-mobile')[0];
  if (menuMobile) {
    ko.applyBindings(new MenuViewModel(), menuMobile);
  }

  if ($('body').hasClass('localizationMode')) {
    $('body').on('click', (e) => {
      if (isTekstNøkkel(e.target.innerHTML) && !e.ctrlKey) {
        e.preventDefault();
        e.stopPropagation();
        const url = `${RazorGlobals.SaksbehandlingWebUrl}/localizationadmin/?ResourceSet=Resources&ResourceId=${e.target.innerHTML.trim()}`;
        window.open(url, '_blank');
      }
    });
    $('body').on('mouseenter', '*', (e) => {
      if (isTekstNøkkel(e.target.innerHTML)) {
        $(e.target).addClass('localizationMode--edit');
      }
    });
    $('body').on('mouseleave', '*', (e) => {
      if (isTekstNøkkel(e.target.innerHTML)) {
        $(e.target).removeClass('localizationMode--edit');
      }
    });
  }
});
